// Polyfills
import "es6-promise/auto";
import "babel-polyfill";

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import VeeValidate from "vee-validate";
import VeeValidatePtBr from 'vee-validate/dist/locale/pt_BR';
import VeeValidateEnGb from 'vee-validate/dist/locale/en';
import App from "./App";
import store from "./store";
import router from "./router";
import { sync } from "vuex-router-sync";
import VuesticPlugin from "vuestic-theme/vuestic-plugin";
import "./i18n";
import DotsLoading from "./DotsLoading.vue";
import VueCarousel from "vue-carousel";
import Multiselect from "vue-multiselect";
import axios from "axios";
import configs from "./services/configs";
import VueCookies from 'vue-cookies'

Vue.component("multiselect", Multiselect);
Vue.component("DotsLoading", DotsLoading);
Vue.use(VuesticPlugin);
Vue.use(VueCarousel);
Vue.use(VueCookies)

sync(store, router);

let mediaHandler = () => {
  if (window.matchMedia(store.getters.config.windowMatchSizeLg).matches) {
    store.dispatch("toggleSidebar", true);
  } else {
    store.dispatch("toggleSidebar", false);
  }
};

/*
var hash = window.location.hash.replace(/#[\/a-z0-9]+\?/ig, '');
var result = hash.split('&').reduce(function (res, item) {
    var parts = item.split('=');
    res[parts[0]] = parts[1];
    return res;
}, {});
if(result.token !== undefined) {
  localStorage.setItem('token', result.token)
}
*/

// Detect browser language
const getBrowserLanguage = () => {
  return navigator.language || navigator.userLanguage;
};
const browserLanguage = getBrowserLanguage();
console.log("Browser language:", browserLanguage);
console.log("Browser language:", browserLanguage.split("-")[0]);
// Set the default language
if(browserLanguage.split("-")[0] === 'pt') {
  Vue.i18n.set('br');
} else {
  Vue.i18n.set('en');
}

router.beforeEach((to, from, next) => {
  store.commit("setLoading", true);
  next();
});

router.afterEach((to, from) => {
  mediaHandler();

  store.commit("setLoading", false);
});

// Merge the locales.
VeeValidate.Validator.localize({
  'br': VeeValidatePtBr,
  'gb': VeeValidateEnGb
});

// NOTE: workaround for VeeValidate + vuetable-2
Vue.use(VeeValidate,
  {
    fieldsBagName: "formFields",
    locale: Vue.i18n.locale(),
  }
);

// Declare Axios and Refresh Token
Vue.prototype.$axios = axios.create({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "api-region": localStorage.getItem("region") || 'BR',
    "X-refresh-token": localStorage.getItem("X-refresh-token") || '',
    "X-refresh-id": localStorage.getItem("userid") || '',
  },
  baseURL: configs.API_URL,
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js